"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenerateAdErrorToJSON = exports.GenerateAdErrorFromJSONTyped = exports.GenerateAdErrorFromJSON = exports.instanceOfGenerateAdError = exports.GenerateAdErrorNameEnum = void 0;
var runtime_1 = require("../runtime");
/**
 * @export
 */
exports.GenerateAdErrorNameEnum = {
    Unknown: 'UNKNOWN',
    ScriptGenerationFailed: 'SCRIPT_GENERATION_FAILED',
    VoiceoverGenerationFailed: 'VOICEOVER_GENERATION_FAILED',
    MixPreviewFailed: 'MIX_PREVIEW_FAILED',
    ScriptOffensive: 'SCRIPT_OFFENSIVE',
    ScriptGuardrailTopic: 'SCRIPT_GUARDRAIL_TOPIC',
    InvalidInput: 'INVALID_INPUT'
};
/**
 * Check if a given object implements the GenerateAdError interface.
 */
function instanceOfGenerateAdError(value) {
    var isInstance = true;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
exports.instanceOfGenerateAdError = instanceOfGenerateAdError;
function GenerateAdErrorFromJSON(json) {
    return GenerateAdErrorFromJSONTyped(json, false);
}
exports.GenerateAdErrorFromJSON = GenerateAdErrorFromJSON;
function GenerateAdErrorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'message': !(0, runtime_1.exists)(json, 'message') ? undefined : json['message'],
    };
}
exports.GenerateAdErrorFromJSONTyped = GenerateAdErrorFromJSONTyped;
function GenerateAdErrorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'message': value.message,
    };
}
exports.GenerateAdErrorToJSON = GenerateAdErrorToJSON;
